import {Component, OnInit, Output, ViewChild, EventEmitter, Inject} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {UploadDocumentComponent} from '../upload-document/upload-document.component';
import {MailFlowComponent} from '../../mail-flow/mail-flow.component';
import {StepperSelectionEvent} from '@angular/cdk/stepper';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatStepper } from '@angular/material/stepper';
import {IdexService} from 'app/idex.service';
import {TranslateService} from '@ngx-translate/core';
import {Toast} from 'app/shared/toast/toast';
import {CreateTaskSignOffComponent} from '../../sign-off/create-task-sign-off/create-task-sign-off.component';

declare var $: any;

@Component({
   selector: 'app-new-task',
   templateUrl: './new-task.component.html',
   styleUrls: ['./new-task.component.css']
})
export class NewTaskComponent implements OnInit {
   @Output()
   selectionChange: EventEmitter<StepperSelectionEvent>;

   @ViewChild(UploadDocumentComponent)
   private uploadComp: UploadDocumentComponent;

   @ViewChild(MailFlowComponent)
   private mailFlowComp: MailFlowComponent;

   @ViewChild(CreateTaskSignOffComponent)
   private createTaskSignOffComp: CreateTaskSignOffComponent;

   @ViewChild(MatStepper) stepper: MatStepper;

   public flowRecipient;
   public messageRecipient;
   public taskAttribute = {
      taskId: 0,
      taskName: '',
      dueDate: '',
      priority: 0,
      templateId: 0,
      workflowId: 0,
      currentLevel: 1,
      retentionPeriod: -1,
      apvLevel: [],
      docList: [],
      message: ''
   };
   private _actionNeedToSign = 'Need to Sign';
   private _actionExternalSign = 'External Sign';
   private _initial = false;
   mode: string;
   errorMessage: any;
   isLinear = true;
   firstFormGroup: FormGroup;
   secondFormGroup: FormGroup;
   thirdFormGroup: FormGroup;
   private _isShowTutorial: any;

   constructor(private _formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) private data: any,
               public service: IdexService,
               public translate: TranslateService,
               private dialogRef: MatDialogRef<NewTaskComponent>,
               public toast: Toast) {
      if (data.taskAttribute) {
         this.taskAttribute = data.taskAttribute;
      }
   }

   ngOnInit() {
      this.firstFormGroup = this._formBuilder.group({
         // firstCtrl: ['', Validators.required]
      });

      this.secondFormGroup = this._formBuilder.group({
         // secondCtrl: ['', Validators.required]
      });
      this.thirdFormGroup = this._formBuilder.group({
         // thirdCtrl: ['', Validators.required]
      });

      this.uploadComp.listTemplate();
      this.translate.get('newTask.fieldTypeName').subscribe((msg) => {
         this.uploadComp.fieldTypeName = msg; // fieldTypeName
      });
      this.uploadComp.isTask = true;
      this.flowRecipient = this.mailFlowComp.flowRecipient;
      this.messageRecipient = this.mailFlowComp.messageRecipient;
      if (this.data.typeName) {
         this.createTaskSignOffComp.typeName = this.data.typeName;
      }

      if (this.data.item) {
         this.createTaskSignOffComp.item = this.data.item;
      }

      if (this.data.typeName === 'startFlow') {
         this.createTaskSignOffComp.type = this.data.typeName;
      }
   }

   uploadChangeStep1() {
      if (this.taskAttribute.taskName === '' || this.taskAttribute.taskName === undefined) {
         this.handleToastError('newTask.errorInputTaskName');
         this.stepper.previous();
         return false;
      } else if (this.taskAttribute.docList.length === 0) {
         this.handleToastError('newTask.errorSelectFile');
         this.stepper.previous();
         return false;
      }
      return true;
   }

   addRecipientChangeStep2() {
      if (this.uploadChangeStep1()) {
         let isNotHaveSigner = false;
         let isRequireNoOfSigner = false;
         let messList = '';

         if (this.taskAttribute.apvLevel.length === 0) {
            this._isShowTutorial = false;
            this.handleToastError('newTask.errorAddRecipient');
            this.stepper.previous();
         }

         for (let i = 0; i < this.taskAttribute.apvLevel.length; i++) {
            if (this.taskAttribute.apvLevel[i].signerList.length === 0) {
               isNotHaveSigner = true;
               if (messList !== '') {
                  messList += ', ';
               }
               messList += (i + 1);
            } else if (this.taskAttribute.apvLevel[i].numOfSigner === 0) {
               for (let j = 0; j < this.taskAttribute.apvLevel[i].signerList.length; j++) {
                  if (this.taskAttribute.apvLevel[i].signerList[j].action.toLowerCase() === 'need to sign') {
                     isRequireNoOfSigner = true;
                     if (messList !== '') {
                        messList += ', ';
                     }
                     messList += (i + 1);
                     break;
                  }
               }
            }
         }

         if (isNotHaveSigner) {
            this._isShowTutorial = false;
            this.handleToastError('newTask.errorAddRecipientOrder', messList);
            this.stepper.previous();
         } else if (isRequireNoOfSigner) {
            this._isShowTutorial = false;
            this.handleToastError('newTask.errorSelectRecipientOrder', messList);
            this.stepper.previous();
         }
      }

      if (this.flowRecipient.groups) {
         for (let i = 0; i < this.flowRecipient.groups.length; i++) {
            this.flowRecipient.groups[i].order = i + 1; // TODO : move to finish button
         }
      }
   }

   onChangeTemplate($event) {
      this.createTaskSignOffComp.isInitail = false;
      this.createTaskSignOffComp.clearAllSign();
   }

   onStepChange($event) {
      switch ($event.selectedIndex) {
         case 0:
            break;
         case 1:
            this.uploadChangeStep1();
            if (this.taskAttribute.workflowId && this.flowRecipient.flow) {
               this.flowRecipient.flow.getFlowList(this.taskAttribute.workflowId);
            }
            break;
         case 2:
            this._isShowTutorial = true;
            this.addRecipientChangeStep2();
            if (this.checkIsNeedToSign() > 0) {
               this.createTaskSignOffComp.leftPanelComp.isHideSigner = true; // fixed bug show signer item when have user action sign
               if (this.taskAttribute.apvLevel.length > 0) {
                  if (this.createTaskSignOffComp.leftPanelComp.toolsComp) {
                     // TODO : debug hide no inject singer when create new  23/04/2561
                     this.createTaskSignOffComp.signerSelected = this.createTaskSignOffComp
                        .leftPanelComp.toolsComp.addNewSigner(this.taskAttribute.apvLevel);
                  }
               }
               this.createTaskSignOffComp.changeDrawPage(this.createTaskSignOffComp.currentIndex); // fixed bug when backward to step
            } else {

               this.createTaskSignOffComp.leftPanelComp.isHideSigner = false; // fixed bug hide signer item when have user action sign
               if (this.taskAttribute.apvLevel.length > 0) {
                  if (this.createTaskSignOffComp.leftPanelComp.toolsComp) {
                     // TODO : debug hide no inject singer when create new  23/04/2561
                     this.createTaskSignOffComp.signerSelected = this.createTaskSignOffComp
                        .leftPanelComp.toolsComp.addNewSigner(this.taskAttribute.apvLevel);
                  }
               }
               this.createTaskSignOffComp.changeDrawPage(this.createTaskSignOffComp.currentIndex); // fixed bug when backward to step
            }
            if (this.createTaskSignOffComp.leftPanelComp.toolsComp) {
               this.createTaskSignOffComp.leftPanelComp.toolsComp.setSigners(this.taskAttribute.apvLevel);
            }
            break;
         default:
            break;
      }
   }

   deleteAllFile(btnBack: any, btnCancel: any, btnSave: any, btnSend: any) {
      this.disableBtn(btnBack, btnCancel, btnSave, btnSend, true);
      if (this.mode !== 'edit') {
         for (let i = 0; i < this.taskAttribute.docList.length; i++) {

            const docId = this.taskAttribute.docList[i].docId;
            if (this.data.item !== undefined && this.data.item.id !== docId) {
               this.service.deleteDocument(docId)
                  .subscribe((response) => {
                     // This is intentional.
                  });
            } else if (this.data.item === undefined) {
               this.service.deleteDocument(docId)
                  .subscribe((response) => {
                     // This is intentional.
                  });
            }
         }
      } else {
         for (let i = 0; i < this.uploadComp.docNew.length; i++) {
            this.service.deleteDocument(this.uploadComp.docNew[i])
               .subscribe((response) => {
                  // This is intentional.
               });
         }
      }
      this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false);
      this.dialogRef.close(false);
   }

   disableBtn(btnBack: any, btnCancel: any, btnSave: any, btnSend: any, isDisable: boolean) {
      if (btnBack) {
         btnBack.disabled = isDisable;
      }
      if (btnCancel) {
         btnCancel.disabled = isDisable;
      }
      if (btnSave) {
         btnSave.disabled = isDisable;
      }
      if (btnSend) {
         btnSend.disabled = isDisable;
      }
   }

   validateSubmit() {
      let isNotHaveSigner = false;
      let isRequireNoOfSigner = false;
      let messList = '';
      if (this.taskAttribute.taskName === '' || this.taskAttribute.taskName === undefined) {
         this.handleToastError('newTask.errorInputTaskName');
         this.stepper.selectedIndex = 0;
         return false;
      } else if (this.taskAttribute.docList.length === 0) {
         this.handleToastError('newTask.errorSelectFile');
         this.stepper.selectedIndex = 0;
         return false;
      } else if (this.taskAttribute.apvLevel.length === 0) {
         this.handleToastError('newTask.errorAddRecipient');
         this.toast.error(this.errorMessage);
         this.stepper.selectedIndex = 1;
         return false;
      }

      for (let i = 0; i < this.taskAttribute.apvLevel.length; i++) {
         if (this.taskAttribute.apvLevel[i].signerList.length === 0) {
            isNotHaveSigner = true;
            if (messList !== '') {
               messList += ', ';
            }
            messList += (i + 1);
         } else if (this.taskAttribute.apvLevel[i].numOfSigner === 0) {
            for (let j = 0; j < this.taskAttribute.apvLevel[i].signerList.length; j++) {
               if (this.taskAttribute.apvLevel[i].signerList[j].action.toLowerCase() === 'need to sign') {
                  isRequireNoOfSigner = true;
                  if (messList !== '') {
                     messList += ', ';
                  }
                  messList += (i + 1);
                  break;
               }
            }
         }
      }

      if (isNotHaveSigner) {
         this.handleToastError('newTask.errorAddRecipientOrder', messList);
         this.stepper.selectedIndex = 1;
         return false;
      } else if (isRequireNoOfSigner) {
         this.handleToastError('newTask.errorSelectRecipientOrder', messList);
         this.stepper.selectedIndex = 1;
         return false;
      }
      return true;
   }

   actionSave(btnBack: any, btnCancel: any, btnSave: any, btnSend: any) {
      this.createTaskSignOffComp.handleWaitAction(true);
      this.disableBtn(btnBack, btnCancel, btnSave, btnSend, true);
      if (this.validateSubmit()) {
         this.createTaskSignOffComp.deselectAll();
         this.service.saveTask(this.taskAttribute)
            .subscribe((suc) => {
                  this.createTaskSignOffComp.handleWaitAction(false);
                  this.uploadComp.submitDeleteFile();
                  this.toast.success(suc);
                  this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false);
                  this.dialogRef.close(true);
               },
               (err) => {
                  this.createTaskSignOffComp.handleWaitAction(false);
                  this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false);
                  console.error(err);
               });
      } else {
         this.createTaskSignOffComp.handleWaitAction(false);
         this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false);
      }
   }

   actionSend(btnBack: any, btnCancel: any, btnSave: any, btnSend: any) {
      this.createTaskSignOffComp.handleWaitAction(true);
      this.disableBtn(btnBack, btnCancel, btnSave, btnSend, true);
      if (this.validateSubmit()) {
         this.createTaskSignOffComp.deselectAll();
         this.addEmptySignItem();
      } else {
         this.createTaskSignOffComp.handleWaitAction(false);
         this.disableBtn(btnBack, btnCancel, btnSave, btnSend, false);
      }
   }

   checkIsNeedToSign() {
      let count = 0;
      for (const signers of this.taskAttribute.apvLevel) {
         for (const signer of signers.signerList) {
            if (signer.action === this._actionNeedToSign || signer.action === this._actionExternalSign) {
               count++;
            }
         }
      }
      return count;
   }

   onFlowChange(data) { // clear signitems in document when change flow
      this.taskAttribute.apvLevel = [];
      for (const apv of data.apvLevel) {
         if (apv.order !== -1) {
            this.taskAttribute.apvLevel.push(apv);
         }
      }
      if (!this.taskAttribute.templateId) {
         for (let i = 0; i < this.taskAttribute.docList.length; i++) {
            this.taskAttribute.docList[i].signItems = [];
         }
      }
   }

   handleToastError(key, msgList?) {
      this.translate.get(key).subscribe((msg) => {
         if (msgList) {
            this.toast.error(msg + msgList);
         } else {
            this.toast.error(msg);
         }
      });
   }

   addEmptySignItem() {
      for (const document of this.taskAttribute.docList) {
         if (!document.signItems) {
            document.signItems = [];
         }
      }
   }

   onDragOverDisable($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.dataTransfer.effectAllowed = 'none';
      $event.dataTransfer.dropEffect = 'none';
   }
}
